<template>
  <div class="sn-f-s-0 sn-navigator" v-if="navigator.key">
    <div class="sn-f-col-c-c top">
      <div class="top-title">{{ navigator.assembly }}</div>
      <div class="top-sub" v-if="navigator.sub">{{ navigator.sub }}</div>
    </div>
    <div class="func">
      <div class="sn-f-c-c sn-omit sn-pointer func-line"
      :class="{'interaction': interaction(item) || item.id === initial}"
      :key="item.id" v-for="item in navigator.func" @click="goFunction(item);">{{ item.alias }}</div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { ErrorConfig } from '@/common/utils/login-config';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import * as Messages from '@/common/utils/messages';

export default {
  name: 'sn-navigator',
  mixins: [HomepageMixin],
  props: {
    id: {
      type: String,
      default: '',
      required: true
    },
    initial: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      navigator: {}
    };
  },
  computed: {
    interaction() {
      return (func) => {
        let verify = false;
        if (func.url === this.$route.path) verify = true;
        if (verify) {
          if (!this.$sn.validate.empty(func.params)) {
            verify = JSON.stringify(func.params) === JSON.stringify(this.$route.query);
          }
        }
        return verify;
      };
    }
  },
  created: function() {
    this.formatNavigator();
  },
  methods: {
    formatNavigator() {
      this.navigator = {};
      const storage = this.$sn.utils.getHospitalSessionStorage('HospitalFunctionTreeInformation');
      if (!this.$sn.validate.empty(storage) && !this.$sn.validate.empty(storage[this.id]) && storage[this.id].assembly && storage[this.id].func.length > 0) {
        this.navigator = {
          ...storage[this.id],
          key: this.id
        };
      }
    },
    goFunction(item) {
      if (this.interaction(item)) return false;
      if (this.$sn.utils.isOpenFunction(item.id)) {
        this.navigateUrl(item.url, item, item.params);
      }
      else {
        // 服务升级公告-当前功能暂未开放
        this.$sn.utils.setHospitalSessionStorage('Homepage_ErrorCaption', {
          title: Messages.C010,
          caption: Messages.C003
        });
        if (this.$route.path === ErrorConfig) window.eventBus.$emit('Broadcast_NavigatorFunction');
        else this.navigateUrl(ErrorConfig);
      }
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
